// Home route → curated per role. Internal staff get the staff dashboard (StaffHome); clients get their
// Orders & Invoices module; reps get their commissions + order history. Clients/reps never see the
// dashboard.
import StaffHome from './StaffHome.jsx';
import ClientHome from './ClientHome.jsx';
import RepHome from './RepHome.jsx';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore.js';
import { takeReturn } from '../lib/returnTo.js';

export default function RoleHome() {
  const role = useAuthStore((s) => s.user?.role);
  const navigate = useNavigate();
  // Signed in via Google (which always returns to "/") after following a link? Go there now.
  useEffect(() => {
    const back = takeReturn();
    if (back) navigate(back, { replace: true });
  }, [navigate]);
  if (role === 'CLIENT') return <ClientHome />;
  if (role === 'REP') return <RepHome />;
  return <StaffHome />;
}
